<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="推送时间" prop="pushDate">
          <el-input v-model="dataForm.pushDate" placeholder="推送时间"></el-input>
      </el-form-item>
          <el-form-item label="客户信息id" prop="customerId">
          <el-input v-model="dataForm.customerId" placeholder="客户信息id"></el-input>
      </el-form-item>
          <el-form-item label="公司信息id" prop="companyId">
          <el-input v-model="dataForm.companyId" placeholder="公司信息id"></el-input>
      </el-form-item>
          <el-form-item label="产品id" prop="productId">
          <el-input v-model="dataForm.productId" placeholder="产品id"></el-input>
      </el-form-item>
          <el-form-item label="门店id" prop="deptId">
          <el-input v-model="dataForm.deptId" placeholder="门店id"></el-input>
      </el-form-item>
          <el-form-item label="撞库推送消息" prop="repeatPushMsg">
          <el-input v-model="dataForm.repeatPushMsg" placeholder="撞库推送消息"></el-input>
      </el-form-item>
          <el-form-item label="撞库返回消息" prop="repeatRespMsg">
          <el-input v-model="dataForm.repeatRespMsg" placeholder="撞库返回消息"></el-input>
      </el-form-item>
          <el-form-item label="撞库状态:0,成功,1:失败" prop="repeatStatus">
          <el-input v-model="dataForm.repeatStatus" placeholder="撞库状态:0,成功,1:失败"></el-input>
      </el-form-item>
          <el-form-item label="推送消息" prop="pushMsg">
          <el-input v-model="dataForm.pushMsg" placeholder="推送消息"></el-input>
      </el-form-item>
          <el-form-item label="推送返回消息" prop="respMsg">
          <el-input v-model="dataForm.respMsg" placeholder="推送返回消息"></el-input>
      </el-form-item>
          <el-form-item label="推送状态:0,成功,1:失败" prop="pushStatus">
          <el-input v-model="dataForm.pushStatus" placeholder="推送状态:0,成功,1:失败"></el-input>
      </el-form-item>
          <el-form-item label="更新人" prop="updateBy">
          <el-input v-model="dataForm.updateBy" placeholder="更新人"></el-input>
      </el-form-item>
              <el-form-item label="更新日期" prop="updateTime">
          <el-input v-model="dataForm.updateTime" placeholder="更新日期"></el-input>
      </el-form-item>
          <el-form-item label="删除日期" prop="deleteTime">
          <el-input v-model="dataForm.deleteTime" placeholder="删除日期"></el-input>
      </el-form-item>
          <el-form-item label="" prop="msg">
          <el-input v-model="dataForm.msg" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="" prop="status">
          <el-input v-model="dataForm.status" placeholder=""></el-input>
      </el-form-item>
          <el-form-item label="推送id" prop="pushId">
          <el-input v-model="dataForm.pushId" placeholder="推送id"></el-input>
      </el-form-item>
          <el-form-item label="反馈类型（1已注册、0未注册）" prop="callStatus">
          <el-input v-model="dataForm.callStatus" placeholder="反馈类型（1已注册、0未注册）"></el-input>
      </el-form-item>
          <el-form-item label="回调时间" prop="callDate">
          <el-input v-model="dataForm.callDate" placeholder="回调时间"></el-input>
      </el-form-item>
          <el-form-item label="回调内容" prop="callBack">
          <el-input v-model="dataForm.callBack" placeholder="回调内容"></el-input>
      </el-form-item>
          <el-form-item label="下游id" prop="orderId">
          <el-input v-model="dataForm.orderId" placeholder="下游id"></el-input>
      </el-form-item>
          <el-form-item label="单价" prop="price">
          <el-input v-model="dataForm.price" placeholder="单价"></el-input>
      </el-form-item>
          <el-form-item label="计划推送时间" prop="scheduleTime">
          <el-input v-model="dataForm.scheduleTime" placeholder="计划推送时间"></el-input>
      </el-form-item>
          <el-form-item label="是否推送（0否、1是）" prop="isPush">
          <el-input v-model="dataForm.isPush" placeholder="是否推送（0否、1是）"></el-input>
      </el-form-item>
          <el-form-item label="返回上游价格" prop="channelPrice">
          <el-input v-model="dataForm.channelPrice" placeholder="返回上游价格"></el-input>
      </el-form-item>
          <el-form-item label="产品结算价格" prop="settlementPrice">
          <el-input v-model="dataForm.settlementPrice" placeholder="产品结算价格"></el-input>
      </el-form-item>
          <el-form-item label="渠道推广价" prop="channelPromPrice">
          <el-input v-model="dataForm.channelPromPrice" placeholder="渠道推广价"></el-input>
      </el-form-item>
      <!-- <el-form-item label-width="120px" label="是否扣量" prop="deduct">
	      <el-select style="width: 200px;" v-model="dataForm.deduct" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in isPushs"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item> -->
      <el-form-item label-width="120px" label="是否计数" prop="deductFlag">
	      <el-select style="width: 200px;" v-model="dataForm.deductFlag" filterable clearable placeholder="请选择">
	          <el-option
	                  v-for="item in isPushs"
	                  :key="item.value"
	                  :label="item.label"
	                  :value="item.value">
	          </el-option>
	      </el-select>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        pushDate: '',
        customerId: '',
        companyId: '',
        productId: '',
        deptId: '',
        repeatPushMsg: '',
        repeatRespMsg: '',
        repeatStatus: '',
        pushMsg: '',
        respMsg: '',
        pushStatus: '',
        updateBy: '',
        creator: '',
        createDate: '',
        updateTime: '',
        deleteTime: '',
        msg: '',
        status: '',
        pushId: '',
        callStatus: '',
        callDate: '',
        callBack: '',
        orderId: '',
        price: '',
        scheduleTime: '',
        isPush: '',
        channelPrice: '',
        settlementPrice: '',
        channelPromPrice: '',
        deductFlag:'',
        deduct: '',
      }
    }
  },
  computed: {
    dataRule () {
      return {
        pushDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        customerId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        companyId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deptId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        repeatPushMsg: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        repeatRespMsg: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        repeatStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushMsg: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        respMsg: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateBy: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deleteTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        msg: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        status: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pushId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        callStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        callDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        callBack: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        orderId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        price: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        scheduleTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isPush: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channelPrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        settlementPrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        channelPromPrice: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/customerpushlog0512archive/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/customerpushlog0512archive/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
